import PixelMark from "./PixelMark";

const ITEMS = [
  "THE CHECKFLOW SYSTEM™",
  "DIGITAL NAIL SIZING",
  "CLIENT MEASUREMENTS",
  "STYLE LIBRARY",
  "BUSINESS ANALYTICS",
  "SHIPPING",
];

const DOTS = ["bg-pastel-blue", "bg-pastel-mint", "bg-white"];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-lg font-extrabold uppercase tracking-tight text-ink md:text-xl">
            {item}
          </span>
          <PixelMark
            className={`h-4 w-4 ${DOTS[i % DOTS.length]} text-ink`}
          />
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden py-8" aria-hidden="true">
      <div
        data-testid="genz-marquee"
        className="marquee -mx-2 -rotate-1 border-y-2 border-ink bg-pastel-pink py-3"
      >
        <div className="marquee-track">
          {row("a")}
          {row("b")}
        </div>
      </div>
    </div>
  );
}
